import YAML from "yaml";

const defaultParams: Record<string, any> = {
  appstatus: {},
  camshot: {},
  cmd: { cmd: 'dir "C:\\"' },
  enabledebug: { cheque: true },
  getchequedump: {},
  getintegration: {},
  getlog: { todayonly: true, iiko: false },
  get_logs: { days: 1 },
  getstore: { todayonly: true },
  get_store: { path: "" },
  httpsaction: { action: "" },
  iniaction: { file: "", action: "", section: "", key: "", value: "" },
  loadfile: { url: "" },
  load_file: { url: "" },
  resendcheques: { folders: "" },
  resetcheques: {},
  reset_data: { module_name: "" },
  togglewindow: { action: true, screenshot: null },
  set_config: { config: {}, restart: true },
  update: {},
  upload: { file: "" },
};

const getDefaultParams = (): Record<string, string> => {
  const doc = new YAML.Document();

  const defaultParamsYaml: Record<string, string> = {};
  for (const method in defaultParams) {
    doc.contents = defaultParams[method];
    const yamlParams =
      Object.keys(defaultParams[method]).length === 0 ? "" : doc.toString();
    defaultParamsYaml[method] = yamlParams;
  }
  console.log("yaml res", defaultParamsYaml);
  return defaultParamsYaml;
};

export const defaultParamsYaml = getDefaultParams();
